import { Component, OnInit } from '@angular/core';
import * as Feather from 'feather-icons';

@Component({
  selector: 'app-iddpricelist',
  templateUrl: './iddpricelist.component.html',
  styleUrls: ['./iddpricelist.component.css']
})
export class IddpricelistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

ngAfterViewInit() {
    Feather.replace();
  }

}
